"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.selectShortcutsEnabled = exports.selectViewer = exports.selectLastAction = exports.selectIsWritingCue = exports.selectCueNoteVisibility = exports.selectCuesMuted = exports.selectActiveCues = exports.selectIsSeeking = exports.selectReadyState = exports.selectPaused = exports.selectVideo = exports.selectHasEnded = exports.selectHasFailed = exports.selectIsSubmittingCueNote = exports.selectIsTakingNote = exports.selectIsPaused = exports.selectCurrentSrc = exports.selectIsWaiting = exports.selectHasStarted = exports.selectWithSidePanel = exports.selectIsFullscreen = exports.selectPlaybackRate = exports.selectSeekTime = exports.selectMuted = exports.selectVolume = exports.selectBuffered = exports.selectDuration = exports.selectCurrentTime = exports.selectIsActive = exports.selectCues = exports.selectMetadataTracks = exports.selectTextTracks = exports.selectPercent = exports.selectCueFormElem = exports.selectRootElem = exports.selectResource = exports.selectFormattedTime = exports.selectFormattedDuration = exports.selectFormattedRemainingTime = void 0;
var format_video_time_1 = require("../utils/format-video-time");
var selectFormattedRemainingTime = function (state) {
    var _a, _b, _c, _d, _e, _f;
    return (0, format_video_time_1.formatVideoTime)(((_c = (_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.duration) !== null && _c !== void 0 ? _c : 0) -
        ((_f = (_e = (_d = state.context.videoRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.currentTime) !== null && _f !== void 0 ? _f : 0));
};
exports.selectFormattedRemainingTime = selectFormattedRemainingTime;
var selectFormattedDuration = function (state) { var _a, _b; return (0, format_video_time_1.formatVideoTime)((_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.duration); };
exports.selectFormattedDuration = selectFormattedDuration;
var selectFormattedTime = function (state) {
    var _a, _b, _c, _d;
    return (0, format_video_time_1.formatVideoTime)((_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.currentTime, (_d = (_c = state.context.videoRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.duration);
};
exports.selectFormattedTime = selectFormattedTime;
var selectResource = function (state) { var _a; return (_a = state.context.resource) !== null && _a !== void 0 ? _a : {}; };
exports.selectResource = selectResource;
var selectRootElem = function (state) {
    var _a, _b;
    return (_b = (_a = state.context.rootElemRef) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : null;
};
exports.selectRootElem = selectRootElem;
var selectCueFormElem = function (state) { var _a, _b; return (_b = (_a = state.context.cueFormElemRef) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : null; };
exports.selectCueFormElem = selectCueFormElem;
var selectPercent = function (state) {
    var _a;
    if (!((_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current))
        return 0;
    var _b = state.context.videoRef.current, currentTime = _b.currentTime, duration = _b.duration;
    var seekingTime = state.context.seekingTime;
    var time = seekingTime || currentTime;
    var percent = time / duration;
    return percent >= 1 ? 1 : percent;
};
exports.selectPercent = selectPercent;
var selectTextTracks = function (state) {
    var _a;
    var video = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current;
    if (!video)
        return;
    return video.textTracks;
};
exports.selectTextTracks = selectTextTracks;
var selectMetadataTracks = function (state) {
    return state.context.metadataTracks;
};
exports.selectMetadataTracks = selectMetadataTracks;
var selectCues = function (state) {
    var noteTracks = state.context.metadataTracks.filter(function (track) {
        return track.label === 'notes';
    });
    return noteTracks.reduce(function (acc, track) {
        return __spreadArray(__spreadArray([], acc, true), Array.from(track.cues || []), true);
    }, []);
};
exports.selectCues = selectCues;
var selectIsActive = function (state) {
    return state.context.isActive || false;
};
exports.selectIsActive = selectIsActive;
var selectCurrentTime = function (state) { var _a, _b; return ((_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.currentTime) || 0; };
exports.selectCurrentTime = selectCurrentTime;
var selectDuration = function (state) { var _a, _b; return ((_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.duration) || 0; };
exports.selectDuration = selectDuration;
var selectBuffered = function (state) { var _a, _b; return ((_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.buffered) || 0; };
exports.selectBuffered = selectBuffered;
var selectVolume = function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.volume) !== null && _c !== void 0 ? _c : 0.8; };
exports.selectVolume = selectVolume;
var selectMuted = function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.muted) !== null && _c !== void 0 ? _c : false; };
exports.selectMuted = selectMuted;
var selectSeekTime = function (state) { var _a, _b, _c, _d; return (_d = (_a = state.context.seekingTime) !== null && _a !== void 0 ? _a : (_c = (_b = state.context.videoRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.currentTime) !== null && _d !== void 0 ? _d : 0; };
exports.selectSeekTime = selectSeekTime;
var selectPlaybackRate = function (state) { var _a; return (_a = state.context.playbackRate) !== null && _a !== void 0 ? _a : 1.0; };
exports.selectPlaybackRate = selectPlaybackRate;
var selectIsFullscreen = function (state) { var _a; return (_a = state.context.isFullscreen) !== null && _a !== void 0 ? _a : false; };
exports.selectIsFullscreen = selectIsFullscreen;
var selectWithSidePanel = function (state) {
    return state.context.withSidePanel;
};
exports.selectWithSidePanel = selectWithSidePanel;
var selectHasStarted = function (state) {
    return state.context.hasStarted || false;
};
exports.selectHasStarted = selectHasStarted;
var selectIsWaiting = function (state) {
    return state.context.waiting || false;
};
exports.selectIsWaiting = selectIsWaiting;
var selectCurrentSrc = function (state) { var _a, _b; return (_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.currentSrc; };
exports.selectCurrentSrc = selectCurrentSrc;
var selectIsPaused = function (state) {
    return state.matches('ready.paused');
};
exports.selectIsPaused = selectIsPaused;
var selectIsTakingNote = function (state) {
    return state.matches('taking_note');
};
exports.selectIsTakingNote = selectIsTakingNote;
var selectIsSubmittingCueNote = function (state) { return state.context.isSubmittingCueNote || false; };
exports.selectIsSubmittingCueNote = selectIsSubmittingCueNote;
var selectHasFailed = function (state) {
    return state.matches('failure');
};
exports.selectHasFailed = selectHasFailed;
var selectHasEnded = function (state) {
    return state.matches('ready.ended');
};
exports.selectHasEnded = selectHasEnded;
var selectVideo = function (state) { var _a, _b; return (_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : null; };
exports.selectVideo = selectVideo;
var selectPaused = function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.context.videoRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.paused) !== null && _c !== void 0 ? _c : false; };
exports.selectPaused = selectPaused;
var selectReadyState = function (state) { var _a; return (_a = state.context.readyState) !== null && _a !== void 0 ? _a : -1; };
exports.selectReadyState = selectReadyState;
var selectIsSeeking = function (state) {
    return state.context.seeking;
};
exports.selectIsSeeking = selectIsSeeking;
var selectActiveCues = function (state) {
    return state.context.activeCues;
};
exports.selectActiveCues = selectActiveCues;
var selectCuesMuted = function (state) {
    return state.context.cuesMuted;
};
exports.selectCuesMuted = selectCuesMuted;
var selectCueNoteVisibility = function (state) { return state.context.writingCueNoteVisibility; };
exports.selectCueNoteVisibility = selectCueNoteVisibility;
var selectIsWritingCue = function (state) {
    return state.context.writingCueNote;
};
exports.selectIsWritingCue = selectIsWritingCue;
var selectLastAction = function (state) {
    return state.context.lastAction;
};
exports.selectLastAction = selectLastAction;
var selectViewer = function (state) {
    return state.context.viewer;
};
exports.selectViewer = selectViewer;
var selectShortcutsEnabled = function (state) {
    return state.context.shortcutsEnabled;
};
exports.selectShortcutsEnabled = selectShortcutsEnabled;
